import { useNavigate } from "react-router-dom";
import { Home, MedalStarAlt } from "@boxicons/react";
import { Community } from "@boxicons/react";
import { Images } from "@boxicons/react";
import { Spanner } from "@boxicons/react";
import { ContactBook } from "@boxicons/react";

export const LateralNav = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/english');
    };
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (
        <section className="lateralNav">
            <div className="navPhone-buttons" onClick={() => scrollToSection('beginning')}>
                <Home pack="filled" fill="#fff" className="i-nav" />
                <p>Inicio</p>
            </div>
            <div className="navPhone-buttons" onClick={() => scrollToSection('about')}>
                <Community pack="filled" fill="#fff" className="i-nav" />
                <p>Nosotros</p>
            </div>
            <div className="navPhone-buttons" onClick={() => scrollToSection('gallery')}>
                <Images pack="filled" fill="#fff" className="i-nav" />
                <p>Galeria</p>
            </div>
            <div className="navPhone-buttons" onClick={() => scrollToSection('works')}>
                <Spanner pack="filled" fill="#fff" className="i-nav" />
                <p>Servicios</p>
            </div>
            <div className="navPhone-buttons" onClick={() => scrollToSection('clients')}>
                <MedalStarAlt pack="filled" fill="#fff" className="i-nav" />
                <p>Clientes</p>
            </div>
            <div className="navPhone-buttons" onClick={() => scrollToSection('footer')}>
                <ContactBook pack="filled" fill="#fff" className="i-nav" />
                <p>Contacto</p>
            </div>
            <div className="navPhone-buttons" onClick={handleClick}>
                <p>English</p>
            </div>
        </section>
    )
}